import { render, staticRenderFns } from "./maintainBill.vue?vue&type=template&id=84f52344&scoped=true&"
import script from "./maintainBill.vue?vue&type=script&lang=js&"
export * from "./maintainBill.vue?vue&type=script&lang=js&"
import style0 from "./maintainBill.vue?vue&type=style&index=0&id=84f52344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f52344",
  null
  
)

export default component.exports